import React, { ReactNode } from 'react';

import { MAX_RELOADS } from 'shared/ui/ErrorBoundary/constants';
import { incrementReloadCount, resetReloadCount } from 'shared/ui/ErrorBoundary/lib';
import { ErrorWithHelpLink } from 'shared/ui/ErrorWithHelpLink';

class ErrorCatcher extends React.Component<{ children: ReactNode }, { hasError: boolean }> {
  state = { hasError: false };

  componentDidCatch() {
    const reloads = incrementReloadCount();
    // чтобы не релоадилось бесконечно
    if (reloads <= MAX_RELOADS) {
      setTimeout(() => {
        window.location.reload();
      }, 50);
    } else {
      this.setState({ hasError: true });
      resetReloadCount();
    }
  }

  render() {
    if (this.state.hasError) {
      return <ErrorWithHelpLink />;
    }

    return this.props.children;
  }
}

export function ErrorBoundary({ children }: { children: ReactNode }) {
  return <ErrorCatcher>{children}</ErrorCatcher>;
}
